import { createContext, useContext } from "react";

export const GoogleMapsContext = createContext({
  placesEnabled: false,
});

export function useGoogleMapsPlaces() {
  return useContext(GoogleMapsContext);
}
